import { dataTrophySolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrophySolid = /*#__PURE__*/createIcon(dataTrophySolid)
export default IconTrophySolid
